export const Menus = [
  "Living Room",
  "CEO’s Office",
  "Conference Room",
  "Lobby",
];

export const CardTitle = {
  color: "#FFFFFF",
  fontSize: 28,
  fontWeight: 400,
  paddingTop: 3,
};
export const IconButtonStyle = (theme: any) => {
  return {
    width: 98,
    height: 61,
    background: "#3E3E3E",
    borderRadius: 2.5,
    [theme.breakpoints.down('sm')]: {
      // width: 80,
      marginRight: "15px"
    }
  }
};

export const VolumeIconsStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
};

export const volumeGridStyle = (theme: any) => {
  return {
    [theme.breakpoints.down("il")]: {
      display: "flex",
      justifyContent: "center"
    },

  }
}
export interface VolumePanels {
  pv1: number,
  pvStatus1: boolean,
  pv2: number,
  pvStatus2: boolean
}

export const silderMarks = [
  {
    value: +36,
    label: "+36",
  },
  {
    value: +24,
    label: "+24",
  },
  {
    value: +12,
    label: "+12",
  },
  {
    value: 0,
    label: "0",
  },
  {
    value: -10,
    label: "-10",
  },
  {
    value: -21,
    label: "-21",
  },
  {
    value: -32,
    label: "-32",
  },
  {
    value: -42,
    label: "-42",
  },
  {
    value: -53,
    label: "-53",
  },
  {
    value: -64,
    label: "-64",
  },
];

export interface volumePanel {
  panel: number;
  value: number;
}
